export default class AlphaVideo2DPlayer {
  private writeCtx: CanvasRenderingContext2D;
  private readCtx: CanvasRenderingContext2D;
  private readonly readCanvas: HTMLCanvasElement;
  private video: HTMLVideoElement;
  private frameRequestId: number;
  private writeCanvas: HTMLCanvasElement;

  constructor(canvas: HTMLCanvasElement) {
    this.writeCanvas = canvas;
    this.writeCtx = canvas.getContext('2d');

    this.readCanvas = document.createElement('canvas');
    this.readCtx = this.readCanvas.getContext('2d');

    this.video = null;
    this.frameRequestId = null;
  }

  draw() {
    if (this.video.readyState > this.video.HAVE_METADATA) {
      const width = this.readCanvas.width;
      const height = this.readCanvas.height / 2;

      this.readCtx.drawImage(this.video, 0, 0);

      const maskFrame = this.readCtx.getImageData(0, height, width, height);
      const frameData = new Uint32Array(maskFrame.data.buffer);
      const dataLength = frameData.length;

      let framePixelIdx = 0;

      while (framePixelIdx < dataLength) {
        frameData[framePixelIdx] = frameData[framePixelIdx++] << 8;
      }

      this.writeCtx.putImageData(maskFrame, 0, 0);
      this.writeCtx.drawImage(this.readCanvas, 0, 0, width, height, 0, 0, width, height);
    }
  }

  play(video: HTMLVideoElement) {
    const width = video.videoWidth;
    const height = video.videoHeight;
    this.readCanvas.width = width;
    this.readCanvas.height = height;
    this.writeCanvas.width = width;
    this.writeCanvas.height = height / 2;
    this.video = video;

    this.writeCtx.globalCompositeOperation = 'source-in';

    if (!this.frameRequestId) {
      const render = () => {
        this.draw();
        this.frameRequestId = requestAnimationFrame(render);
      };
      this.frameRequestId = requestAnimationFrame(render);
    }
  }

  stop() {
    cancelAnimationFrame(this.frameRequestId);
    this.frameRequestId = null;
  }
}
